import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  close() {
    this.element.close()
  }

  backdropClose(event) {
    if (event.target === this.element) this.element.close()
  }

  noop() {}
}
